import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';
import { produce } from 'immer';

var fixCustomReportsIds = (data) => {
  return produce(data, (draft) => {
    draft.layout = Object.entries(data.layout).reduce(
      (acc, [key, element]) => {
        return __spreadProps(__spreadValues({}, acc), {
          [key]: __spreadProps(__spreadValues({}, element), {
            id: Number(element.id)
          })
        });
      },
      {}
    );
    draft.customReportComponents = Object.entries(
      data.customReportComponents
    ).reduce(
      (acc, [key, element]) => {
        if (!element)
          return __spreadProps(__spreadValues({}, acc), { [key]: null });
        return __spreadProps(__spreadValues({}, acc), {
          [key]: __spreadProps(__spreadValues({}, element), {
            id: 0
          })
        });
      },
      {}
    );
  });
};

export { fixCustomReportsIds };
